export const CREATE_EXIT_PASS_REQUEST = "CREATE_EXIT_PASS_REQUEST";
export const FETCH_EXIT_PASS_REQUESTS = "FETCH_EXIT_PASS_REQUESTS";
export const FETCH_EXIT_PASS_REQUEST = "FETCH_EXIT_PASS_REQUEST";
export const EDIT_EXIT_PASS_REQUEST = "EDIT_EXIT_PASS_REQUEST";
export const DELETE_EXIT_PASS_REQUEST = "DELETE_EXIT_PASS_REQUEST";
